import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../utils/api";

export const getNhomDichVu = createAsyncThunk("nhomDichVu/getNhomDichVu", async (params = {}, { rejectWithValue }) => {
  try {
    const res = await api.get("/product.category", {
      params: {
        size: params.size || 1000,
        order: "id desc",
        page: params.page || 1,
        operating_unit_id: localStorage.getItem("selected_operating_unit_id"),
        categ_type: "service",
      },
    });
    // Trả về cả content và totalElements để phân trang
    console.log("Fetched nhomDichVu data:", res.data.content);
    return res.data.content || [];
  } catch (err) {
    console.log("err ", err);
    return rejectWithValue(err.response?.data || err.message);
  }
});

export const createNhomDichVu = createAsyncThunk("nhomDichVu/createNhomDichVu", async (payload, { rejectWithValue }) => {
  console.log("Adding new customer with data:", payload);
  try {
    const res = await api.post("/product.category", {
      ...payload,
      operating_unit_id: parseInt(localStorage.getItem("selected_operating_unit_id")),
    });
    return res.data;
  } catch (err) {
    console.log("err ", err);
    return rejectWithValue(err.response?.data || err.message);
  }
});

export const editNhomDichVu = createAsyncThunk("nhomDichVu/editNhomDichVu", async ({ id, data }, { rejectWithValue }) => {
  try {
    const res = await api.put(`/product.category/${id}`, {
      ...data,
      operating_unit_id: parseInt(localStorage.getItem("selected_operating_unit_id")),
    });
    return res.data;
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});

const nhomDichVuSlice = createSlice({
  name: "nhomDichVu",
  initialState: {
    list: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createNhomDichVu.fulfilled, (state, action) => {
        state.loading = false;
        state.list.push(action.payload);
      })
      .addCase(getNhomDichVu.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(editNhomDichVu.fulfilled, (state, action) => {
        state.loading = false;
        const idx = state.list.findIndex((d) => d.id === action.payload.id);
        if (idx > -1) state.list[idx] = { ...state.list[idx], ...action.payload };
      });
  },
});

export default nhomDichVuSlice.reducer;
